import React from 'react'
import styles from './EmptyRides.scss'
import {Card} from 'common/styleguide/Card'
import {CTA} from 'common/styleguide/CTA'
import recordGraphic from './record-graphic.svg'
import Select from 'react-select'
import * as libPhone from 'libphonenumber-js'
import fetchJSON from 'lib/fetchJSON'

const ERROR_TEXT = 'We had an issue sending your text, please check your phone number and try again.'

export class EmptyRides extends React.PureComponent {
  state = {
    messageType: 'install_link_ios',
    phoneNumber: '',
    error: null,
    smsState: null
  }

  onSubmit = (e) => {
    e.preventDefault()
    const {messageType, phoneNumber, smsState} = this.state
    if (smsState === 'pending') { return }

    const parsed = libPhone.parse(phoneNumber, {country: {default: 'US'}})

    if (!parsed.phone || !libPhone.isValidNumber(parsed)) {
      this.setState({
        error: ERROR_TEXT
      })
      return
    }

    const body = {
      phone_number: libPhone.format(parsed, 'International_plaintext'),
      message_type: messageType
    }

    this.setState({smsState: 'pending', error: null})
    fetchJSON(`/sms_messages`, body, {method: 'POST'})
      .then(() => this.setState({smsState: 'success'}))
      .catch(() => this.setState({smsState: null, error: ERROR_TEXT}))
  }

  render () {
    const {messageType, phoneNumber, smsState, error} = this.state
    return (
      <div className={styles.EmptyRides}>
        <h2 data-heading-alt>Rides</h2>
        <Card className={styles.mainCard}>
          <img className={styles.recordGraphic} src={recordGraphic} alt='phone recording ride' />
          <h1 data-heading-alt>Record Rides</h1>
          <div className={styles.leadText}>
            <h2>Record rides and navigate routes using the Ride with GPS mobile app. Enter your mobile phone number to get started.</h2>
          </div>
          <form className={styles.form} onSubmit={this.onSubmit}>
            <div className={styles.compoundInput}>
              <div className={styles.Select}>
                <Select
                  searchable={false}
                  clearable={false}
                  value={messageType}
                  onChange={e => this.setState({messageType: e.value})}
                  options={[
                    {label: 'iOS', value: 'install_link_ios'},
                    {label: 'Android', value: 'install_link_android'}
                  ]} />
              </div>
              <input
                value={phoneNumber}
                onChange={e => this.setState({phoneNumber: e.target.value})}
                className={styles.phoneInput}
                id='userphone'
                type='tel'
                autoComplete='off'
                placeholder='(000) 000 - 0000' />
            </div>
            <CTA button type='submit'>
              {smsState === 'pending' && 'Sending...'}
              {smsState === 'error' && 'Retry'}
              {smsState === 'success' && 'Install link sent!'}
              {smsState === null && 'Send Free Download'}
            </CTA>
            {error && <p>{error}</p>}
            <p className={styles.smallText}>
              *We will never store this information, standard rates apply
            </p>
          </form>
          <hr />
          <div className={styles.cols}>
            <div>
              <h3>Garmin Connect</h3>
              <p>
                Sync rides recorded on your Garmin unit to Ride with GPS via Garmin Connect
              </p>
              <a data-card-link href='https://ridewithgps.com/help/automatic-sync-with-garmin-connect'>Learn more about Garmin Connect</a>
            </div>
            <div>
              <h3>Wahoo Sync</h3>
              <p>
                Wahoo ELEMNT and BOLT devices sync automatically with Ride with GPS
              </p>
              <a data-card-link href='https://ridewithgps.com/help/wahoo-elemnt'>Learn more about Wahoo Sync</a>
            </div>
            <div>
              <h3>Other Devices</h3>
              <p>
                Ride with GPS is compatible with most GPS devices and sensors
              </p>
              <a data-card-link href='https://ridewithgps.com/help/compatible-devices'>Learn More about compatible devices</a>
            </div>
          </div>
        </Card>
      </div>
    )
  }
}
